export default __webpack_public_path__ + "static/media/crates_commander_1.9a55c1ff.png";